@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import xyz.malefic.home.components.layouts.MainLayout as _xyz_malefic_home_components_layouts_MainLayout
import xyz.malefic.home.pages.HomePage as _xyz_malefic_home_pages_HomePage
import xyz.malefic.home.pages.WorkPage as _xyz_malefic_home_pages_WorkPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Malefic"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "xyz.malefic.home.components.layouts.MainLayout",
        ) { pageCtx, pageMethod -> 
            _xyz_malefic_home_components_layouts_MainLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "xyz.malefic.home.components.layouts.MainLayout",
        ) { pageCtx -> 
            _xyz_malefic_home_pages_HomePage()
        }
        ctx.router.register(
            "/work",
            layoutId = "xyz.malefic.home.components.layouts.MainLayout",
        ) { pageCtx -> 
            _xyz_malefic_home_pages_WorkPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("side-nav-container", xyz.malefic.home.components.sections.SideNavContainerStyle)
        ctx.theme.registerStyle("side-nav-header", xyz.malefic.home.components.sections.SideNavHeaderStyle)
        ctx.theme.registerStyle("side-nav-footer", xyz.malefic.home.components.sections.SideNavFooterStyle)
        ctx.theme.registerStyle("commit-row-base", xyz.malefic.home.components.sections.CommitRowBaseStyle)
        ctx.theme.registerStyle("commit-row-link", xyz.malefic.home.components.sections.CommitRowLinkStyle)
        ctx.theme.registerStyle("head-commit-row", xyz.malefic.home.components.sections.HeadCommitRowStyle)
        ctx.theme.registerStyle("graph-gutter", xyz.malefic.home.components.sections.GraphGutterStyle)
        ctx.theme.registerStyle("graph-line", xyz.malefic.home.components.sections.GraphLineStyle)
        ctx.theme.registerStyle("commit-node", xyz.malefic.home.components.sections.CommitNodeStyle)
        ctx.theme.registerStyle("head-commit-node", xyz.malefic.home.components.sections.HeadCommitNodeStyle)
        ctx.theme.registerStyle("commit-message", xyz.malefic.home.components.sections.CommitMessageStyle)
        ctx.theme.registerStyle("footer-container", xyz.malefic.home.components.sections.FooterContainerStyle)
        ctx.theme.registerStyle("footer-stats", xyz.malefic.home.components.sections.FooterStatsStyle)
        ctx.theme.registerStyle("boot-sequence", xyz.malefic.home.components.sections.BootSequenceStyle)
        ctx.theme.registerStyle("nav-item", xyz.malefic.home.components.sections.NavItemStyle)
        ctx.theme.registerStyle("inactive-nav-item", xyz.malefic.home.components.sections.InactiveNavItemStyle)
        ctx.theme.registerStyle("active-nav-item", xyz.malefic.home.components.sections.ActiveNavItemStyle)
        ctx.theme.registerStyle("header-container", xyz.malefic.home.components.sections.HeaderContainerStyle)
        ctx.theme.registerStyle("brand", xyz.malefic.home.components.sections.BrandStyle)
        ctx.theme.registerStyle("header-icon-button", xyz.malefic.home.components.sections.HeaderIconButtonStyle)
        ctx.theme.registerStyle("main-layout", xyz.malefic.home.components.layouts.MainLayoutStyle)
        ctx.theme.registerStyle("masonry", xyz.malefic.home.components.widgets.MasonryStyle)
        ctx.theme.registerStyle("masonry-squared", xyz.malefic.home.components.widgets.MasonrySquaredStyle)
        ctx.theme.registerStyle("masonry-item", xyz.malefic.home.components.widgets.MasonryItemStyle)
        ctx.theme.registerStyle("skill-small-span", xyz.malefic.home.components.widgets.SkillSmallSpanStyle)
        ctx.theme.registerStyle("skill-medium-span", xyz.malefic.home.components.widgets.SkillMediumSpanStyle)
        ctx.theme.registerStyle("skill-large-span", xyz.malefic.home.components.widgets.SkillLargeSpanStyle)
        ctx.theme.registerStyle("env-small-span", xyz.malefic.home.components.widgets.EnvSmallSpanStyle)
        ctx.theme.registerStyle("env-medium-span", xyz.malefic.home.components.widgets.EnvMediumSpanStyle)
        ctx.theme.registerStyle("env-large-span", xyz.malefic.home.components.widgets.EnvLargeSpanStyle)
        ctx.theme.registerStyle("fluency-segment", xyz.malefic.home.components.widgets.FluencySegmentStyle)
        ctx.theme.registerStyle("filled-fluency-segment", xyz.malefic.home.components.widgets.FilledFluencySegmentStyle)
        ctx.theme.registerStyle("environment-item", xyz.malefic.home.components.widgets.EnvironmentItemStyle)
        ctx.theme.registerStyle("terminal-title", xyz.malefic.home.components.widgets.TerminalTitleStyle)
        ctx.theme.registerStyle("terminal-tile", xyz.malefic.home.components.widgets.TerminalTileStyle)
        ctx.theme.registerStyle("interactive-terminal-tile", xyz.malefic.home.components.widgets.InteractiveTerminalTileStyle)
        ctx.theme.registerStyle("stretched-link", xyz.malefic.home.components.widgets.StretchedLinkStyle)
        ctx.theme.registerStyle("raised-link", xyz.malefic.home.components.widgets.RaisedLinkStyle)
        ctx.theme.registerStyle("terminal-header", xyz.malefic.home.components.widgets.TerminalHeaderStyle)
        ctx.theme.registerStyle("journal-small-span", xyz.malefic.home.components.widgets.JournalSmallSpanStyle)
        ctx.theme.registerStyle("journal-medium-span", xyz.malefic.home.components.widgets.JournalMediumSpanStyle)
        ctx.theme.registerStyle("journal-large-span", xyz.malefic.home.components.widgets.JournalLargeSpanStyle)
        ctx.theme.registerStyle("journal-log", xyz.malefic.home.components.widgets.JournalLogStyle)
        ctx.theme.registerStyle("blinking-cursor", xyz.malefic.home.components.widgets.BlinkingCursorStyle)
        ctx.theme.registerStyle("hero-span", xyz.malefic.home.pages.HeroSpanStyle)
        ctx.theme.registerStyle("about-tall-span", xyz.malefic.home.pages.AboutTallSpanStyle)
        ctx.theme.registerStyle("about-small-span", xyz.malefic.home.pages.AboutSmallSpanStyle)
        ctx.theme.registerKeyframes("fade-in", xyz.malefic.home.components.layouts.FadeIn)
        ctx.theme.registerKeyframes("blink", xyz.malefic.home.components.widgets.Blink)
        xyz.malefic.home.styles.initColor(ctx)
        xyz.malefic.home.styles.initTypography(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        xyz.malefic.home.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
